module.exports = __webpack_public_path__ + "static/media/colorpicker.d881e9f6.png";